import { EXTERNAL_SCOPE_TYPES } from './messaging-user';
import { MODEL_NAMES } from '../constants/index';
import { equal } from 'macro-decorators';
import { service } from '@ember/service';
import Model, { attr, belongsTo } from '@ember-data/model';

export const AWAY_MESSAGE_TEXT_MAX_LENGTH = 600;
export const AWAY_MESSAGE_DEFAULT_TEXT =
  "I'm currently unavailable. If this is a medical emergency, please call 911 or any local emergency room.";

export default class MessagingProfileModel extends Model {
  @service messagingLogging;

  @belongsTo(MODEL_NAMES.SYSTEM_USER, { async: false, inverse: null }) systemUser;
  @belongsTo(MODEL_NAMES.USER, { async: false, inverse: null }) user;

  @attr('boolean') isAway;
  @attr('boolean') isSuperUser;

  @attr('string') awayMessageText;
  @attr('string') externalScope;
  @attr('string') name;

  @attr({
    defaultValue() {
      return [];
    },
  })
  unreadConversationIds;

  @equal('externalScope', EXTERNAL_SCOPE_TYPES.user) isClinician;
  @equal('externalScope', EXTERNAL_SCOPE_TYPES.client) isClient;

  addUnreadConversation(conversationId) {
    const stringifiedId = `${conversationId}`;
    if (!this.unreadConversationIds.includes(stringifiedId)) {
      this.unreadConversationIds = [...this.unreadConversationIds, stringifiedId];
    }
  }

  removeUnreadConversation(conversationId, { shouldTrack = true } = {}) {
    const stringifiedId = `${conversationId}`;
    if (this.unreadConversationIds.includes(stringifiedId)) {
      this.unreadConversationIds = this.unreadConversationIds.filter(id => id !== stringifiedId);
      if (!shouldTrack) return;

      this.messagingLogging.trackEvent('emc.tracking_event_names.unread_conversation_viewed', {
        conversation_id: conversationId,
      });
    }
  }
}
